<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
export default {
	props: {},
	watch: {},
	data() {
		return {
			//搜索框
			searchlist: getdata().searchlist,
			// 红字发票确认信息 表格
			tableData: [{}, {}, {}, {}, {}],
			headData: getdata().headData,
			tablekey: 0,
			shaidiag: false,
			outlist: localStorage.getItem('informationEntryoutlist'),
			overlength:0,
			//页签切换
			activeName:"0"
		};
	},
	mounted() {},
	created() {},
	methods: {
		geOoverLength(e) {
			this.overlength = e;
		},
		//返回
		switchInterfaceHuid() {
			this.$emit('switchInterfaceHuid', 0);
		},
		// 表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		// 存缓存示例
		confirmfilter(e) {
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
		},
		// 表格字段排序
		sortchange(e) {
			console.log(e);
		},
		// 显示条数
		sizechange(e) {
			this.pagination.pageSize = e;
		},
		// 显示页码
		currentChange(e) {
			this.pagination.pageNum = e;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
